import Api from "../../../Api";
import ReactDOMClient from "react-dom/client";
import TeambookDialog from "../TeambookDialog";
import DangerPic from "../../default_images/danger_deletion.svg";

const bookingPrecheckModal = async (precheckBookings, t) => {
  let precheckResult;

  await Api.Bookings.precheck_bookings(precheckBookings).then((res) => {
    precheckResult = res.data;
  });

  return new Promise((resolve) => {
    if (precheckResult.status === "ok") {
      resolve("ok");
      return;
    }

    const modalRoot = ReactDOMClient.createRoot(document.getElementById("teambook-question-modal"));
    const modalText = {
      warning: precheckResult.warnings[0],
      error: precheckResult.errors[0],
    }

    const Modal = () => (
      <TeambookDialog
        onClose={close}
        open={true}
        htmlTitle={
          <div style={{display: "flex", flexDirection: "column", alignItems: "center", marginBottom: "20px", width: "100%"}}>
            <img style={{width: 50, height: 50}} src={DangerPic}/>
          </div>
        }
        content={
          <p style={{textAlign: "center", fontSize: "18px"}}>{modalText[precheckResult.status]}</p>
        }
        actionButtons={[
          {
            text: precheckResult.status === "warning" ? t("cancel") : t("close"),
            onClick: close,
            type: "outlined",
          },
          {
            text: t("move_anyway"),
            onClick: continueCreation,
          },
        ].filter(button => precheckResult.status === "warning" || button.text !== t("move_anyway"))}
      />
    );

    const continueCreation = () => {
      removeModal();
      resolve("ok");
    }

    const close = () => {
      removeModal();
      resolve("skip");
    };

    const removeModal = () => {
      modalRoot.unmount();
    }

    modalRoot.render(<Modal/>)
    // ReactDOMClient.createRoot(<Modal />, modalRoot);
  });
}

export default bookingPrecheckModal;
